export default "__VITE_ASSET__BWSfbB_$__"